import {WlModal} from "../../../webcomponents/modal/modal.component";
import localStorage from "../../../core/localStorage";
import dom from "../../../core/dom";
import actions from "../../../../../mitula/ts/components/retention/email/form/actions";
import FormValidations from "../../../forms/validator/FormValidations";
import {SaveSearchModalInterface} from "./SaveSearchModalInterface";


export default class SaveSearchModal implements SaveSearchModalInterface{

    readonly saveSearchModal: WlModal
    readonly isPaid: boolean
    readonly isDesktop: boolean
    readonly search: string
    readonly saveActualSearchFormId: string
    readonly openedByCTA: boolean

    constructor(search:string,isPaid: boolean, isDesktop: boolean, saveActualSearchFormId:string, modalId:string = "#js_save-actual-search-modal", openedByCTA:boolean = true) {
        this.search = search
        this.isPaid = isPaid
        this.isDesktop = isDesktop
        this.saveSearchModal = document.querySelector<WlModal>(modalId)!
        this.saveActualSearchFormId = saveActualSearchFormId
        this.openedByCTA = openedByCTA
    }

    public init = () => {
        actions.init();
        this.setupEventListeners();
    };

    private setupEventListeners = () => {
        if (!this.saveSearchModal) return;

        if(this.openedByCTA) {
            if (this.openedByCTA) {
                const saveSearchCTA = dom.select("#save-search-opener");
                saveSearchCTA?.addEventListener('click', () => {
                    this.openModal()
                });
            }
        }

            let formElement = dom.select(`#${this.saveActualSearchFormId}`) as HTMLFormElement;
            let saveActualSearchButton = formElement.querySelector("[type=submit]");
            saveActualSearchButton?.addEventListener('click', () => {
                let acceptNewsCheckbox = formElement.querySelector("input[name='accept-news']") as HTMLInputElement;
                let wantsNews =  acceptNewsCheckbox?.checked ?? false;
                const formData = new FormData(formElement);
                formData.append("search", this.search);
                let emailValue = formData.get("email")?.toString() ?? "";
                let emailInput = formElement.querySelector("input");
                if(FormValidations.emailIsValid(emailValue) ){
                    emailInput?.classList.remove("error");
                    actions.submitSaveActualSearchForm(formData, this.saveActualSearchFormId, this.isPaid, this.saveActualSearchFormId, this.isDesktop, wantsNews)
                    this.saveSearchModal.close();
                } else {
                    emailInput?.classList.add("error");
                }
            });

            let saveSimilarSearchButtons = document.querySelectorAll('.js_save-similar-search-button');
            saveSimilarSearchButtons?.forEach((button) => {
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    // @ts-ignore
                    alert("voy a guardar la búsqueda "+ button.dataset.search);
                });
            });
    };

    public openModal = () => {
        if (!this.saveSearchModal) return;
        this.saveSearchModal.open();
        let emailValue = localStorage?.getItem("email") ?? "";
        emailValue = emailValue ? emailValue : "";
        actions.emitPopulateFormEvent(this.saveActualSearchFormId, emailValue);
        if(this.saveActualSearchFormId.startsWith("save-actual-search")) {
            actions.clickSaveActualSearchCTA(this.saveActualSearchFormId, this.isPaid, this.isDesktop);
        }
    }
}

